import * as z from 'zod';

export type ServiceProviderFormSchemaValues = z.infer<typeof serviceProviderFormSchema>;
export const serviceProviderFormSchema = z.object({
    name: z.string().nonempty(),
    legal_address: z.string().nonempty(),
    representative: z.string().nonempty(),
    uic: z.string().nonempty(),
    tax_number: z.string().nonempty(),
});
